import {ThemePalette} from '@angular/material/core';

export class MenuItem {
  label: string = '';
  url?: string;
  icon?: string;
  isActive: boolean = false;
  imageType: "icon" | "image" | "none" = "none";
  visible: boolean = true;
  color?: ThemePalette;
  class?: string;
  mode?: 'list' | 'button';
  badgeCounter?: number;

  children?: MenuItem[];


  onClick?: () => void;

  constructor(item: Partial<MenuItem>, route?: string) {
    this.mode = 'list';
    Object.assign(this, item);
    if (route) {
      this.setRoute(route);
    }
  }

  setRoute(route: string) {
    // C8: match the exact url OR a proper sub-path (`url + '/'`), not a bare prefix
    // — otherwise `/events-admin` lit up BOTH "Tutti gli Eventi" (/events) and
    // "Eventi (Admin)" (/events-admin). Sub-pages (e.g. /events/123) still highlight.
    this.isActive = this.url ? (route === this.url || route.startsWith(this.url + '/')) : false;
  }
}
